(function () {
  function init(section) {
    if (!section || section.dataset.heroInit === '1') return;
    section.dataset.heroInit = '1';

    var img = section.querySelector('.hero-ook__img');
    if (!img) return;

    var floatDisabled =
      section.classList.contains('hero-ook--no-float') ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (floatDisabled) {
      // Leave the image static — no scroll tilt, no float loop, no inline transform.
      return;
    }

    var startTime = performance.now();
    var rotation = 0;
    var raf = null;

    function updateRotation() {
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var progress = Math.min(1, Math.max(0, (vh - rect.top) / (vh + rect.height)));
      rotation = -progress * 14;
    }

    function loop(now) {
      var elapsed = (now - startTime) / 1000;
      var floatY = Math.sin((elapsed / 6) * Math.PI * 2) * 12;
      img.style.transform = 'translateY(' + floatY.toFixed(2) + 'px) rotate(' + rotation.toFixed(2) + 'deg)';
      requestAnimationFrame(loop);
    }

    function onScroll() {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        updateRotation();
        raf = null;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    updateRotation();
    requestAnimationFrame(loop);
  }

  function initAll() {
    document.querySelectorAll('.hero-ook').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.hero-ook');
    if (section) init(section);
  });
})();